module.exports = __webpack_public_path__ + "assets/img/2816.23076676.svg";